import { Input, Select, TextField } from '@mui/material';
import { useEffect, useReducer } from 'react';
import Modal from 'react-modal';
import CloseIcon from '@mui/icons-material/Close';
import CustomButtonSimple from '../../../../../components/CustomMiscellaneous/CustomButtonSimple';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        display: 'flex',
        transform: 'translate(-50%, -50%)',
        overflow: 'auto',
        justifyContent: 'center'
    },
};


export function MedidasConvencionalModal({ isOpen, onCancel, onConfirm, initialValues }: { isOpen: boolean, onCancel: Function, onConfirm: Function, initialValues?: any }) {

    const [medidas, setMedidas] = useReducer((state: any, action: any) => {
        return { ...state, ...action }
    }, { largura: initialValues? initialValues.largura: 0, altura: initialValues? initialValues.altura: 0, comprimento: initialValues? initialValues.comprimento: 0 })


    return (
        <Modal style={customStyles} isOpen={isOpen}>
            <div className='p-1 w-[500px]'>
                <div className='flex justify-between mb-3'>
                    <h2 className='font-bold'>Introduza as medidas do bloco preparado</h2>
                    <CloseIcon onClick={() => onCancel()} className="cursor-pointer"/>
                </div>
                <div className='p-3'>
                    <div className='flex justify-between items-center'>
                        <p>Largura (mm)</p>
                        <TextField type="number" variant="outlined" value={medidas.largura} onChange={(e) => setMedidas({ largura: parseFloat(e.target.value) })} placeholder="Largura" />
                    </div>
                    <div className='flex justify-between items-center'>
                        <p>Altura (mm)</p>
                        <TextField type="number" value={medidas.altura} onChange={(e) => setMedidas({ altura: parseFloat(e.target.value) })} placeholder="Altura" />
                    </div>
                    <div className='flex justify-between items-center'>
                        <p>Comprimento (mm)</p>
                        <TextField type="number" value={medidas.comprimento} onChange={(e) => setMedidas({ comprimento: parseFloat(e.target.value) })} placeholder="Comprimento" />
                    </div>
                </div>
                <div className='flex justify-end p-3'>
                    <CustomButtonSimple text="Confirmar" onClick={()=> onConfirm(medidas)}/>
                </div>
            </div>

        </Modal>
    )


}